export enum SizingTypeRef {
  ppa_price = 'ppa_price',
  pv_and_battery = 'pv_and_battery'
}

export enum SizingAlgorithmRef {
  algo_v3_hybrid = 'algo_v3_hybrid',
  algo_v3 = 'algo_v3',
  algo_multi_genset = "algo_multi_genset"
}
